import {
  useAPIGetListPerencanaanPenilik,
  usePerencanaanPenilikListSummary,
} from 'api/kinerja/tim-penilai-penilik/perencanaan'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

import type { PerencanaanFilterState } from 'types/kinerja-tim-penilai-penilik'

export default function usePerencanaanList({
  filter,
  isEnabled = true,
}: {
  filter: PerencanaanFilterState
  isEnabled?: boolean
}) {
  const { isPPKPenilik, isTKPenilik, isProfilePenilikPegawaiFetched } =
    useRoleContext()

  const {
    data: summary,
    isLoading: isSummaryLoading,
    isFetched: isSummaryFetched,
  } = usePerencanaanPenilikListSummary({
    opts: {
      enabled: isProfilePenilikPegawaiFetched && (isPPKPenilik || isTKPenilik),
    },
  })

  const {
    data,
    isLoading: isListLoading,
    isFetched: isListFetched,
  } = useAPIGetListPerencanaanPenilik({
    filter,
    opts: {
      enabled:
        isEnabled &&
        isProfilePenilikPegawaiFetched &&
        (isPPKPenilik || isTKPenilik),
    },
  })

  return {
    data,
    summary,
    isLoading: isListLoading || isSummaryLoading,
    isFetched: isListFetched && isSummaryFetched,
  }
}
